<ng-template #changeStatus>
  <aw-box-dialog-status-transition (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)"
    [box]="box"></aw-box-dialog-status-transition>
</ng-template>

<ng-container *ngIf="enableBox else changeStatus">
  <aw-enable-box (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)" [box]="box"></aw-enable-box>
</ng-container>